import React from 'react';
import {browserHistory} from "react-router";

export const pageTransition = (path, e) => {

    if( e && e.currentTarget.getAttribute('link') === window.location.pathname ){ return }

    // Media query to run curtain only on desktop
    let mql = window.matchMedia('(min-width: 1199px)');
    if (mql.matches) {
        // Add class to curtain for page transition animation
        const curtain = document.getElementsByClassName('theme-curtain');
        curtain.length && curtain[0].classList.add('active');
        setTimeout(() => {
            window.scrollTo(0, 0);
            browserHistory.push(path);
        }, 500);
        setTimeout(() => {
            curtain.length && curtain[0].classList.remove('active');
        }, 1000);
    } else {
        browserHistory.push(path);
        // Removing class from body to hide nav for mobile after clicking on link to change page.
        const link = document.getElementsByTagName('body');
        link[0].classList.remove('mobile-nav-active');
        // ----
    }

 }


// WEBPACK FOOTER //
// src/client/components/dashboardNew/functions/pageTransition.js